<template>
    <div id="footer" class="sportsfooter">
        <footer class="midFooter">
            <ul class="service"></ul>
            <ul class="nav">
                <li id="rnr" @click.prevent="viewSportRules(0)">{{ langList.rules }}</li>
                <!--li id="faq">常見疑問</li-->
                <!-- <li id="settings" @click.prevent="viewSportRules(1)">詳細設定</li> -->
            </ul>
            <div class="copyright">© Copyright 2021. 3 SING SPORT. All Rights Reserved.</div>
        </footer>
    </div>
</template>

<script>


import {
  mapGetters
} from 'vuex'

export default {
    components: {
        
    },
    computed: {
      ...mapGetters([
        'langList'
      ]),
    },
    methods : {
      viewSportRules(param){
        if(param == 0){
          let height = window.screen.availHeight-50;
          let width = window.screen.availWidth-100;
          if(width>1024){
              width=1024;
          }
          window.open('sport-information?c='+param, 'MsgWindow', 'width='+width+', height='+height+'')
        }
      },
    }, 
}
</script>



// WEBPACK FOOTER //
// resources/wob/vue/apps/sport/footerContent.vue